import { createSlice } from "@reduxjs/toolkit";
import { createErrorReportingAsyncThunk } from "../../helpers";
import { apiFetch } from "../../../helpers/api-fetch";

export type StopUnitTemplate = {
  id: string;
  name: string;
  description: string;
  quantity: string | null;
  weight: string | null;
  colli: string | null;
  length: string | null;
  width: string | null;
  height: string | null;
  volume: string | null;
};

export type WebBookingStopUnit = {
  id: string;
  stopUnitTemplateId: string;
  description: string;
  quantity: string | null;
  weight: string | null;
  colli: string | null;
  length: string | null;
  width: string | null;
  height: string | null;
  volume: string | null;

  fromStopId: string;
  toStopId: string | null;
};

type State = {
  templates: StopUnitTemplate[];
};

const initialState: State = {
  templates: [],
};

export const loadStopUnitTemplates = createErrorReportingAsyncThunk(
  "data/stop-unit-templates/load",
  async () => {
    const result = await apiFetch("/web-booking-api/stop-unit-templates");
    if (!result.ok) {
      throw new Error("Error loading stop unit templates");
    }
    return result.json() as Promise<StopUnitTemplate[]>;
  }
);

const slice = createSlice({
  name: "data/stop-unit-templates",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadStopUnitTemplates.fulfilled, (state, action) => {
      state.templates = action.payload;
    });
  },
});

export const selectStopUnitTemplates = (state: {
  data: { stopUnitTemplates: State };
}): StopUnitTemplate[] => state.data.stopUnitTemplates.templates;

export default slice.reducer;
